import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-white shadow overflow-hidden rounded-2xl" }
const _hoisted_2 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "px-4 py-4 flex items-center sm:px-6" }
const _hoisted_5 = { class: "min-w-0 flex-1 sm:flex sm:items-center sm:justify-between" }
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = { class: "flex text-sm" }
const _hoisted_8 = { class: "font-medium ml-3 text-gray-500" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 flex-shrink-0 sm:mt-0 sm:ml-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex overflow-hidden -space-x-1" })
], -1)

import { computed } from 'vue';
import { CheckIcon } from '@heroicons/vue/outline';
import { Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';


export default /*#__PURE__*/_defineComponent({
  props: {
    suggestedPromotion: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  suggestedPromotion: Promotion,
}


const actions = computed(() => {
  return props.suggestedPromotion.actions.filter((action) => {
    return action.discountDescription !== '';
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(actions), (action) => {
        return (_openBlock(), _createElementBlock("li", {
          key: action.name
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(CheckIcon), {
                      class: "flex-shrink-0 w-6 h-6 text-brand-secondary-accent",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(action.discountDescription), 1)
                  ])
                ]),
                _hoisted_9
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})